exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apc-react-body .language-targeting .select-operator {\n  max-width: 75px; }\n\n.apc-react-body .language-targeting .select-language {\n  width: 100%; }\n  .apc-react-body .language-targeting .select-language .language-option {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n", ""]);

// exports
